import { PUBLIC_VOICE_ALIGN_WEBSITE } from '$env/static/public';
import { createAuthClient } from 'better-auth/svelte';
import { emailOTPClient } from 'better-auth/client/plugins';
import { firebaseIntegrationClientPlugin } from './firebaseIntegrationClientPlugin';

export const authClient = createAuthClient({
	baseURL: PUBLIC_VOICE_ALIGN_WEBSITE,
	sessionOptions: { refetchOnWindowFocus: false },
	plugins: [firebaseIntegrationClientPlugin(), emailOTPClient()]
});
